module.exports = __webpack_public_path__ + "img/email-1.2583b8de.jpg";